import api from '../../services/api';
import {
  SendMessageRequest,
  SendMessageResponse,
  Message
} from '../types/message.types';
import {
  Conversation,
  ConversationListResponse,
  CreateConversationRequest,
  CreateConversationResponse
} from '../types/conversation.types';

class ChatbotApiService {
  // ==================== CONVERSATIONS ====================

  /**
   * Créer une nouvelle conversation
   */
  async createConversation(data?: CreateConversationRequest): Promise<CreateConversationResponse> {
    try {
      const response = await api.post('/api/chatbot/conversations/', data || {});
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création de la conversation:', error);
      throw error;
    }
  }

  /**
   * Récupérer la liste des conversations
   */
  async getConversations(page: number = 1, pageSize: number = 20): Promise<ConversationListResponse> {
    try {
      const response = await api.get('/api/chatbot/conversations/', {
        params: { page, page_size: pageSize }
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des conversations:', error);
      throw error;
    }
  }

  /**
   * Récupérer une conversation spécifique
   */
  async getConversation(conversationId: string): Promise<Conversation> {
    try {
      const response = await api.get(`/api/chatbot/conversations/${conversationId}/`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de la conversation:', error);
      throw error;
    }
  }

  /**
   * Fermer une conversation
   */
  async closeConversation(conversationId: string): Promise<void> {
    try {
      await api.post(`/api/chatbot/conversations/${conversationId}/close/`, {});
    } catch (error) {
      console.error('Erreur lors de la fermeture de la conversation:', error);
      throw error;
    }
  }

  // ==================== MESSAGES ====================

  /**
   * Envoyer un message et recevoir la réponse de l'IA
   */
  async sendMessage(data: SendMessageRequest): Promise<SendMessageResponse> {
    try {
      const response = await api.post('/api/chatbot/messages/', data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'envoi du message:', error);
      throw error;
    }
  }

  /**
   * Récupérer les messages d'une conversation
   */
  async getMessages(conversationId: string): Promise<Message[]> {
    try {
      const response = await api.get(`/api/chatbot/messages/${conversationId}/`);
      return response.data.messages || [];
    } catch (error) {
      console.error('Erreur lors de la récupération des messages:', error);
      throw error;
    }
  }

  // ==================== UTILITAIRES ====================

  /**
   * Vérifier le statut du service chatbot
   */
  async healthCheck(): Promise<boolean> {
    try {
      const response = await api.get('/api/chatbot/health/');
      return response.data.status === 'ok';
    } catch (error) {
      console.error('Service chatbot indisponible:', error);
      return false;
    }
  }
}

export const chatbotApiService = new ChatbotApiService();
export default chatbotApiService;
